import Styles from './HelpDropdown.module.scss'
import { Drawer } from 'components/Drawer'
import { DrawerProps } from 'components/Drawer/Root'
import { observer } from 'mobx-react-lite'
import { Heading } from 'blaze-ui/Heading/Heading'
import { HelpSections, HelpSectionsProps } from './HelpSections'

export const HelpDrawer = observer((props: DrawerProps & HelpSectionsProps) => {
  const { close, videoTutorialType } = props

  return (
    <Drawer.Root activeSnapPoint={1} snapPoints={[1]} {...props}>
      <Drawer.Portal>
        <Drawer.Content>
          <Drawer.InnerContent>
            <Drawer.Top>
              <Drawer.Close label="" />
              <Drawer.Title asChild>
                <Heading level={5}>Help</Heading>
              </Drawer.Title>
              <Drawer.Close variant="ghost" position="right" />
            </Drawer.Top>
            <Drawer.Container className={Styles.drawerContainer}>
              <HelpSections close={close} menuType="tray" videoTutorialType={videoTutorialType} />
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
})
